import { ApexOnlineMenu, menuItems, menuPermissions } from 'apex-online-menu'
import { MenuItem } from 'apex-ui-services'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getAppConfigSetting } from '../../utils'
import useAccount from '../../hooks/useAccount'

const apiUrl: string = getAppConfigSetting('apiUrl') as string

export interface Props {
  menuItems: MenuItem[]
  menuPermissions: any
  menuItemsRequest: (apiUrl: string) => void
  menuPermissionsRequest: (apiUrl: string) => void
  signedIn: boolean
  handleSignout: () => void
}

export const ApexMenuComponent = ({
  menuItems,
  menuPermissions,
  menuItemsRequest,
  menuPermissionsRequest,
  signedIn,
  handleSignout
}: Props) => {
  const { account } = useAccount()

  useEffect(() => {
    if (signedIn) {
      menuItemsRequest(apiUrl)
      menuPermissionsRequest(apiUrl)
    }
  }, [signedIn, menuItemsRequest, menuPermissionsRequest])

  const getLegacyURL = (): string | null => {
    const cookie = document.cookie
    const parts = cookie.split(';')
    const apexURL = parts.find((p) => p.includes('apexOnlineURL'))
    if (apexURL) {
      return apexURL.split('URL=')[1]
    }
    return null
  }
  return (
    <>
      <ApexOnlineMenu
        items={menuItems}
        userPermissions={menuPermissions}
        legacyUrl={getLegacyURL()}
        showLogout={signedIn}
        logout={handleSignout}
        accountNumber={account?.accountNumber}
      />
    </>
  )
}

const mapDispatchToProps = {
  menuItemsRequest: menuItems.request,
  menuPermissionsRequest: menuPermissions.request
}

const mapStateToProps = (state: any) => ({
  menuItems: menuItems.selectors.menuItemsResults(state),
  menuPermissions: menuPermissions.selectors.menuPermissionsResults(state)
})

export const ApexMenu = connect(mapStateToProps, mapDispatchToProps)(ApexMenuComponent)
